import React from "react";
import "../css/ProfileCard.css"; // external CSS for styling
import imagePath from "../Images/Image/WhatsApp-Image-2024-09-02-at-14.24.01_3f7a24ef-e1725267984159-249x300.jpg";

const ProfileCard = () => {
  return (
    <div className="profile-container">
      {/* Left side: Image */}
      <div className="profile-image">
        <img src={imagePath} alt="Amit Tiwari" />
      </div>

      {/* Right side: Text */}
      <div className="profile-text">
        <h2>Amit Tiwari</h2>
        <h4>Director</h4>
        <p>
          As the CEO of SKT Construction, I bring a wealth of experience and a
          forward-thinking vision to the machinery rental industry. My journey
          has been marked by a commitment to innovation and excellence, driving
          our company to set new benchmarks in the sector. I am passionate about
          leveraging strategic insights and a hands-on approach to ensure that
          SKT Construction not only meets but exceeds industry standards. My
          goal is to foster a culture of quality and reliability, ensuring that
          every project reflects our dedication to delivering exceptional
          results and unparalleled customer satisfaction.
        </p>

        {/* Social icons */}
        <div className="social-icons">
          <a href="https://facebook.com" target="_blank" rel="noreferrer">
            <i className="fab fa-facebook"></i>
          </a>
          <a href="https://twitter.com" target="_blank" rel="noreferrer">
            <i className="fab fa-twitter"></i>
          </a>
          <a href="https://linkedin.com" target="_blank" rel="noreferrer">
            <i className="fab fa-linkedin"></i>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ProfileCard;